import React from 'react';
import { useTranslation } from 'react-i18next';
import { resolveIntlLocale } from '../../../utils/locale';
import './ExtractionResults.css';

export function ExtractionResults({ documents = [], onReExtract, onUseExtractedData }) {
  const { t, i18n } = useTranslation();
  const locale = resolveIntlLocale(i18n.resolvedLanguage || i18n.language);
  const documentsWithResults = documents.filter(doc => 
    doc.extractionStatus === 'complete' && doc.extractionResults
  );

  if (documentsWithResults.length === 0) {
    return null; // Don't show section if no results
  }

  const formatExtractionValue = (value) => {
    if (value == null || value === '') {
      return t('common.notAvailable');
    }
    if (typeof value === 'number' && Number.isFinite(value)) {
      return new Intl.NumberFormat(locale).format(value);
    }
    if (typeof value === 'boolean') {
      return value ? t('common.yes') : t('common.no');
    }
    if (typeof value === 'string') {
      const shortIsoDatePattern = /^\d{4}-\d{2}-\d{2}$/;
      const dateTimePattern = /^\d{4}-\d{2}-\d{2}T/;
      if (shortIsoDatePattern.test(value) || dateTimePattern.test(value)) {
        const parsedDate = new Date(value);
        if (!Number.isNaN(parsedDate.getTime())) {
          return new Intl.DateTimeFormat(locale, {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
          }).format(parsedDate);
        }
      }
      return value;
    }
    if (Array.isArray(value)) {
      return value.map(item => formatExtractionValue(item)).join(', ');
    }
    if (typeof value === 'object') {
      return JSON.stringify(value);
    }
    return String(value);
  };

  const getFieldLabel = (key) => {
    const translationKey = `reports.workspace.documents.extractionFields.${key}`;
    return t(translationKey, {
      defaultValue: key
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, (str) => str.toUpperCase()),
    });
  };

  return (
    <div className="extraction-results">
      <div className="extraction-results__documents">
        {documentsWithResults.map((doc) => (
          <div key={doc.id} className="extraction-results__document">
            <div className="extraction-results__document-header">
              {doc.name}
            </div>
            <div className="extraction-results__fields">
              {doc.extractionResults && Object.entries(doc.extractionResults).map(([key, value]) => {
                if (key === 'extractedAt' || key === 'fields') return null;
                return (
                  <div key={key} className="extraction-results__field">
                    <div className="extraction-results__field-label">
                      {getFieldLabel(key)}
                    </div>
                    <div className="extraction-results__field-value">
                      {formatExtractionValue(value)}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
